import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import './index.css';
import { loadRuntimeConfig } from './config/env';

async function bootstrap() {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element (#root) not found in index.html');
  }

  const root = createRoot(rootElement);

  try {
    // Attempt to load runtime configuration (e.g. public/config.json override)
    await loadRuntimeConfig();
  } catch (err) {
    return;
  }

  // `App` is imported dynamically on purpose: a static `import` would be hoisted
  // and evaluated BEFORE the awaited `loadRuntimeConfig()` above, so apiClient /
  // assetUrl would capture the build-time default instead of config.json's value.
  const { default: App } = await import('./App');

  root.render(
    <StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </StrictMode>
  );
}

bootstrap().catch((err) => {
  return;
});
